import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { ManageIcon } from '@dndbeyond/character-components/es';
import {
    Ability,
    AbilityUtils,
    DeathSaveInfo,
    DiceAdjustment,
    rulesEngineSelectors,
    SituationalSavingThrowInfoLookup,
    CharacterTheme,
    RuleData,
} from '@dndbeyond/character-rules-engine/es';
import { IRollContext } from '@dndbeyond/dice';

import { sidebarActions } from '../../../Shared/actions';
import { Subsection, SubsectionFooter } from '../../../Shared/components/Subsection';
import { appEnvSelectors, characterRollContextSelectors } from '../../../Shared/selectors';
import { AppEnvDimensionsState } from '../../../Shared/stores/typings';
import { PaneComponentEnum, PaneIdentifierUtils } from '../../../Shared/utils';
import SavingThrowsBox from '../../components/SavingThrowsBox';
import { SheetAppState } from '../../typings';

interface Props extends DispatchProp {
    abilities: Array<Ability>;
    ruleData: RuleData;
    savingThrowDiceAdjustments: Array<DiceAdjustment>;
    situationalBonusSavingThrowsLookup: SituationalSavingThrowInfoLookup;
    deathSaveInfo: DeathSaveInfo;
    dimensions: AppEnvDimensionsState;
    theme: CharacterTheme;
    isReadonly: boolean;
    diceEnabled: boolean;
    characterRollContext: IRollContext;
}
class SavingThrowsDesktop extends React.PureComponent<Props> {
    handleManageShow = (): void => {
        const { dispatch } = this.props;
        dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.SAVING_THROWS));
    };

    handleAbilityClick = (ability: Ability): void => {
        const { dispatch } = this.props;
        dispatch(
            sidebarActions.paneHistoryStart(
                PaneComponentEnum.ABILITY_SAVING_THROW,
                PaneIdentifierUtils.generateAbilitySavingThrows(AbilityUtils.getId(ability)),
            ),
        );
    };

    render() {
        const {
            abilities,
            ruleData,
            savingThrowDiceAdjustments,
            situationalBonusSavingThrowsLookup,
            dimensions,
            theme,
            isReadonly,
            diceEnabled,
            deathSaveInfo,
            characterRollContext,
        } = this.props;

        return (
            <Subsection name="Abilities">
                <SavingThrowsBox
                    ruleData={ruleData}
                    abilities={abilities}
                    savingThrowDiceAdjustments={savingThrowDiceAdjustments}
                    situationalBonusSavingThrowsLookup={situationalBonusSavingThrowsLookup}
                    deathSaveInfo={deathSaveInfo}
                    onAbilityClick={this.handleAbilityClick}
                    onInfoClick={this.handleManageShow}
                    dimensions={dimensions}
                    theme={theme}
                    diceEnabled={diceEnabled}
                    rollContext={characterRollContext}
                />
                <SubsectionFooter>
                    <ManageIcon onClick={this.handleManageShow} tooltip={isReadonly ? 'View' : 'Manage'} theme={theme}>
                        Saving Throws
                    </ManageIcon>
                </SubsectionFooter>
            </Subsection>
        );
    }
}

function mapStateToProps(state: SheetAppState) {
    return {
        abilities: rulesEngineSelectors.getAbilities(state),
        ruleData: rulesEngineSelectors.getRuleData(state),
        savingThrowDiceAdjustments: rulesEngineSelectors.getSavingThrowDiceAdjustments(state),
        situationalBonusSavingThrowsLookup: rulesEngineSelectors.getSituationalBonusSavingThrowsLookup(state),
        deathSaveInfo: rulesEngineSelectors.getDeathSaveInfo(state),
        dimensions: appEnvSelectors.getDimensions(state),
        theme: rulesEngineSelectors.getCharacterTheme(state),
        isReadonly: appEnvSelectors.getIsReadonly(state),
        diceEnabled: appEnvSelectors.getDiceEnabled(state),
        characterRollContext: characterRollContextSelectors.getCharacterRollContext(state),
    };
}

export default connect(mapStateToProps)(SavingThrowsDesktop);
